import store from "./store";

const authErrorFeedbackMap = {
  10150: { code: "auth.invalid_login", type: "error" },
  10151: { code: "auth.logout_failed", type: "error" },
  10152: { code: "auth.signup_failed", type: "error" },
  10153: { code: "auth.reset_request_failed", type: "error" },
  10154: { code: "auth.reset_failed", type: "error" },
  10155: { code: "auth.verify_link_resend_failed", type: "error" },
  10156: { code: "auth.verify_failed", type: "error" },
  10158: { code: "auth.oauth_login_hook_failed", type: "error" },
  10160: { code: "auth.oauth_failed", type: "error" },
  10161: { code: "auth.magic_link_request_failed", type: "error" },
  10162: { code: "auth.invite_complete_failed", type: "error" },
  10163: { code: "auth.account_disabled", type: "error" }
};

function setModelAuthFeedback(model, feedback) {
  if (!model) {
    return;
  }

  if (feedback.message !== undefined) {
    Vue.set(model, "authMessage", feedback.message);
  }
  if (feedback.code !== undefined) {
    Vue.set(model, "authMessageCode", feedback.code);
  }
  if (feedback.type !== undefined) {
    Vue.set(model, "authMessageType", feedback.type);
  }
}

function setStoreAuthFeedback(feedback) {
  store.commit("SET_AUTH_FEEDBACK", feedback || null);
}

function clearAuthFeedback(model) {
  if (model) {
    Vue.set(model, "authMessage", "");
    Vue.set(model, "authMessageCode", "");
    Vue.set(model, "authMessageType", "");
  }
  setStoreAuthFeedback(null);
}

function setAuthFeedback(model, feedback) {
  setModelAuthFeedback(model, feedback);
  setStoreAuthFeedback(feedback);
}

function buildAuthErrorFeedback(numericCode, message) {
  const authFeedback = authErrorFeedbackMap[numericCode];

  if (!authFeedback) {
    return null;
  }

  return {
    numericCode,
    code: authFeedback.code,
    message,
    type: authFeedback.type
  };
}

export {
  buildAuthErrorFeedback,
  clearAuthFeedback,
  setAuthFeedback,
  setStoreAuthFeedback
};
